var isBrowser = typeof document !== "undefined";

export { isBrowser };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/is-browser.mjs
// module id = PSwB
// module chunks = 0